import React from 'react'
import PropTypes from 'prop-types'
import PlayerMatchTable from './playerMatchTable'
import NoData from '@shared/components/noData'

const PlayerMatch = ({ playerData, odiData, t20Data, testData }) => {
  return (
    <>
      {odiData?.length === 0 && t20Data?.length === 0 && testData?.length === 0 ? (
        <NoData title="No match data to show just yet—looks like this player is gearing up for their next big innings!"/>
      ) : (
        <>
          <PlayerMatchTable data={odiData} playerData={playerData} />
          <PlayerMatchTable data={t20Data} playerData={playerData} />
          <PlayerMatchTable data={testData} playerData={playerData} />
        </>
      )}
    </>
  )
}

PlayerMatch.propTypes = {
  playerData: PropTypes.object,
  odiData: PropTypes.array,
  t20Data: PropTypes.array,
  testData: PropTypes.testData
}

export default PlayerMatch
